// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { N100, N50 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EmptyStateBox = styled.div({
  display: 'flex',
  justifyContent: 'center',
  border: "var(--ds-border-width, 1px)".concat(" dashed ", "var(--ds-border, ".concat(N50, ")")),
  padding: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var EmptyStateText = styled.p({
  marginTop: "var(--ds-space-050, 0px)",
  color: "var(--ds-text-subtlest, ".concat(N100, ")"),
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  textAlign: 'center'
});